// extracted by mini-css-extract-plugin
export var localeSelector = "_6y-0";